import {
  ColumnConfiguration,
  ColumnConfigurationRenderAs,
} from '@april9au/stack9-sdk';

import { ListTable } from '../../components/ListTable/ListTable';
import { PromoCodeDrawerAction } from '../../components/ListViewCustomComponents';
import { PromoCode } from '../../models/stack9/PromoCode';

const Drawer = PromoCodeDrawerAction.default;

type Props = {
  countrySetupId: number;
  initialValues?: Partial<PromoCode>;
};
const PromoCodeInfo = ({ countrySetupId, initialValues }: Props) => {
  const columns: ColumnConfiguration[] = [
    {
      label: 'Campaign name',
      field: 'campaign_name',
      renderAs: ColumnConfigurationRenderAs.CustomComponent,
      value: '{{campaign_name}}',
      options: {
        customComponentName: 'PromoCodeDrawerAction',
      },
    },
    {
      label: 'Code',
      field: 'code',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{code}}',
    },
    {
      label: 'Start date',
      field: 'start_dt',
      renderAs: ColumnConfigurationRenderAs.Date,
      value: '{{start_dt}}',
      options: {
        noTime: true,
      },
    },
    {
      label: 'End date',
      field: 'end_dt',
      renderAs: ColumnConfigurationRenderAs.Date,
      value: '{{end_dt}}',
      options: {
        noTime: true,
      },
    },
    {
      label: 'Discount percentage',
      field: 'discount_percentage',
      renderAs: ColumnConfigurationRenderAs.Decimal,
      value: '{{discount_percentage}}',
    },
  ];

  return (
    <ListTable
      queryVars={{ countrySetupId }}
      columns={columns}
      title="Promo codes"
      queryName="getpromocodebycountrysetup"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          marginBottom: '15px',
        }}
      >
        <Drawer row={{ ...initialValues }} />
      </div>
    </ListTable>
  );
};

export default PromoCodeInfo;
